const SIZE = 21;
const FINDER = 7;

const isFinderCorner = (x: number, y: number) =>
  (x < FINDER && y < FINDER) ||
  (x >= SIZE - FINDER && y < FINDER) ||
  (x < FINDER && y >= SIZE - FINDER);

/** Whether a cell inside one of the three corner squares is filled. */
function finderCell(x: number, y: number): boolean {
  const fx = x < FINDER ? x : x - (SIZE - FINDER);
  const fy = y < FINDER ? y : y - (SIZE - FINDER);
  const edge = fx === 0 || fy === 0 || fx === FINDER - 1 || fy === FINDER - 1;
  return edge || (fx >= 2 && fx <= 4 && fy >= 2 && fy <= 4);
}

/** A fixed, repeatable pattern of cells. Not a real code: it only stands in for one. */
function filledCells(): Array<[number, number]> {
  const cells: Array<[number, number]> = [];
  let seed = 7 * 9301 + 49297;
  for (let y = 0; y < SIZE; y++) {
    for (let x = 0; x < SIZE; x++) {
      seed = (seed * 9301 + 49297) % 233280;
      const on = isFinderCorner(x, y) ? finderCell(x, y) : seed / 233280 > 0.52;
      if (on) cells.push([x, y]);
    }
  }
  return cells;
}

const CELLS = filledCells();

/** A stand-in picture of a QR code. It does not encode anything. */
export function QrGlyph({ size = 112 }: { size?: number }) {
  return (
    <svg
      viewBox={`0 0 ${SIZE} ${SIZE}`}
      width={size}
      height={size}
      shapeRendering="crispEdges"
      aria-hidden="true"
      style={{ display: 'block', fill: '#111' }}
    >
      {CELLS.map(([x, y]) => (
        <rect key={`${x}-${y}`} x={x} y={y} width="1" height="1" />
      ))}
    </svg>
  );
}
